import React from 'react';
import type { SanityBlock } from '@sanity/client';
import { InfoBox } from '@naf-simba/sections-info-box';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import BlockContent from '../../../BlockContent';
import { BlockContentContext } from '../../../BlockContent.utils';

interface InfoBoxSerializerProps {
  value: {
    displayOption?: 'standard' | 'green' | null;
    highlightedText: string;
    title: string;
    text: SanityBlock[];
  };
}

export const InfoBoxSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: InfoBoxSerializerProps) => (
      <ArticleBlockContentGridCol>
        <InfoBox
          displayColor={value.displayOption || 'standard'}
          highlightedText={value.highlightedText}
          title={value.title}
          content={<BlockContent value={value.text} />}
        />
      </ArticleBlockContentGridCol>
    );
  }

  return ({ value }: InfoBoxSerializerProps) => (
    <InfoBox
      displayColor={value.displayOption || 'standard'}
      highlightedText={value.highlightedText}
      title={value.title}
      content={<BlockContent value={value.text} />}
    />
  );
};
